import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df55926"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "fault-info-block" }
const _hoisted_3 = { class: "boom-info" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "empty"
}
const _hoisted_6 = { class: "log-info van-hairline--top" }
const _hoisted_7 = { class: "log-detail" }
const _hoisted_8 = {
  key: 0,
  class: "empty"
}
const _hoisted_9 = { class: "rang" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = {
  key: 0,
  class: "image-wrap"
}
const _hoisted_12 = ["src", "onClick"]
const _hoisted_13 = {
  key: 1,
  class: "empty"
}
const _hoisted_14 = {
  key: 0,
  class: "description-text"
}
const _hoisted_15 = {
  key: 1,
  class: "empty"
}
const _hoisted_16 = { class: "media-info van-hairline--top" }
const _hoisted_17 = { class: "image-wrap" }
const _hoisted_18 = {
  key: 0,
  class: "xag-ellipsis"
}
const _hoisted_19 = {
  key: 1,
  style: {"color":"rgba(0, 0, 0, 0.22)"}
}

import { useStore } from 'vuex'
import { ImagePreview } from 'vant'
import { computed, Ref, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { createOrder } from '@/apis/malfunction-repair'
// import { commonErrorHandle } from '@/utils/error-handle'
import { clearToast, showConfirmModal, showToastLoading } from '@/utils/tools'
import type {
  MalfunctionRepairDeviceItem,
  CreateMulfunctionRepairOrderParams,
} from '@/types/malfunction-repair'
import {
  useMalfunctionRepairStore,
  useCreateOrderSuccessHandle,
  useMalfunctionRepairAddressInfo,
} from '@/compositions/malfunction-repair/index'
import { MalfunctionRepairSelectedDevicesStorage } from '@/storage/malfunction-repair'

import AppHeader from '@/components/Header.vue'
import CellWrap from './components/cell-wrap.vue'
import LabelTitleWrap from './components/label-title-wrap.vue'
import NetworkInfoBlock from './components/network-info-block.vue'
import FaultFormDeviceInfo from './components/fault-form-device.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import UploadFile from '@/components/upload/newUploadFIle.vue'
import RepairTypeBlock from './components/repair-type-block.vue'
import RepairTypeTipDialog from './components/repair-type-tip-dialog.vue'
import ShrinkWrap from '@/components/shrink-wrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'fault-submit',
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const $store = useStore()
const { createSuccessHandle } = useCreateOrderSuccessHandle()
const { malfunctionRepairState, getUserLocation } = useMalfunctionRepairStore()
const cacheDeviceInfo = MalfunctionRepairSelectedDevicesStorage.get<MalfunctionRepairDeviceItem[]>()
const deviceInfoList: Ref<MalfunctionRepairDeviceItem[]> = ref(cacheDeviceInfo || [])
const isUav = deviceInfoList.value[0]?.type === 1
const { receive_express, addressStr } = useMalfunctionRepairAddressInfo()

const firstData = computed(() => {
  return malfunctionRepairState.firstData
})

const imgList = computed(() => {
  if (!firstData.value) {
    return []
  }
  return firstData.value.files.map((item) => item.url)
})

let RepairTypeBlockRef = ref<InstanceType<typeof RepairTypeBlock>>(null)

const isPay = computed(() => {
  return firstData.value.is_pay === 1
})

let ShrinkWrapRef = ref<InstanceType<typeof ShrinkWrap>>(null)
watch(
  () => {
    if (isPay.value) {
      ShrinkWrapRef.value?.setShrink(true)
    } else {
      ShrinkWrapRef.value?.setShrink(false)
    }
  },
  () => isPay.value
)
watch(
  () => {
    RepairTypeBlockRef.value?.setIsRepair(malfunctionRepairState.firstData.is_pay)
    console.log('设置', firstData.value)
  },
  () => firstData.value
)

const annextList = computed(() => {
  if (!firstData.value) {
    return []
  }
  return firstData.value.annextList
})

function imagePreviewHandler(index: number) {
  ImagePreview({
    images: imgList.value,
    startPosition: index,
  })
}
function toEditAddress() {
  $router.push({
    name: 'malfunction-repair-fault-address',
  })
}
let RepairTypeTipDialogRef = ref<InstanceType<typeof RepairTypeTipDialog>>(null)

function preConfirmSubmit() {
  if (isPay.value) {
    RepairTypeTipDialogRef.value?.setShow(true)
  } else {
    confirmSubmit()
  }
}
async function confirmSubmit() {
  let lnglat: {
    lat?: number | string
    lng?: number | string
    unAuth?: boolean
  } = {}
  let getLngLatErrorMessage = ''
  try {
    lnglat = await getUserLocation()
    if (lnglat.unAuth) {
      getLngLatErrorMessage = '请同意获取您的经纬度信息继续提单操作'
    }
  } catch (error) {
    getLngLatErrorMessage = (error as { message: string })?.message
  }
  if (getLngLatErrorMessage) {
    await showConfirmModal({
      title: '提示',
      confirmButtonText: '我知道了',
      showCancelButton: false,
      message: getLngLatErrorMessage || '获取经纬度失败',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
    })
    return
  }
  const params: CreateMulfunctionRepairOrderParams = deviceInfoList.value.map((item) => {
    return {
      process_type: isUav ? 'P_SERIAL' : 'EQ_OTHER',
      serial_number: item.serial_number,
      images: firstData.value.files.map((item) => item?.response?.guid).filter((val) => val),
      logs: [malfunctionRepairState.selectedLogGuid].filter((item) => item),
      is_boom: malfunctionRepairState.isBoom,
      description: firstData.value.description,
      lat: String(lnglat.lat),
      lng: String(lnglat.lng),
      repair_warehouse_guid: malfunctionRepairState.networkInfo.guid,
      repair_warehouse_type: malfunctionRepairState.networkInfo.type,
      receive_express,
      is_on_site_exemption: Number($route.query.on_site_exemption) || 0,
      annex: annextList.value
        .filter((item) => item.status === 'done')
        .map((item) => {
          let nameArr = item?.response?.fileName.split('.')
          return {
            url: item?.response?.guid,
            suffix: nameArr[nameArr.length - 1],
            file_name: item?.response?.fileName,
          }
        }),
      is_pay: firstData.value.is_pay,
    }
  })
  console.log('params', params)
  try {
    await showConfirmModal({
      className: 'fault-module',
      title: '确定提交？',
      message: '网点接单后，为了检测和维修设备，设备使用权会发生变更。',
    })
  } catch (error) {
    console.log('error', error)
    return
  }
  try {
    showToastLoading()
    const createOrderData = await createOrder(params)
    let guid = createOrderData.guids[0]
    createSuccessHandle(guid, {
      hasMoreDevices: deviceInfoList.value.length > 1,
      is_pay: isPay.value,
    })
  } catch (error) {
    clearToast()
    const errorObj = error as { message: string }
    showConfirmModal({
      title: '提单失败',
      message: errorObj?.message || '',
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
      showCancelButton: false,
    })
  }
}

function repairTypeTipContinue() {
  confirmSubmit()
}
// onUnmounted(() => {

// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "故障报修" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LabelTitleWrap, { title: "报修设备" }),
      _createVNode(FaultFormDeviceInfo, { deviceInfoList: deviceInfoList.value }, null, 8, ["deviceInfoList"]),
      _createVNode(RepairTypeBlock, {
        ref_key: "RepairTypeBlockRef",
        ref: RepairTypeBlockRef,
        class: "repair-type-block",
        isCanSelect: false
      }, null, 512),
      _createVNode(NetworkInfoBlock),
      _createVNode(ShrinkWrap, {
        class: "falut-info-block",
        title: "故障信息",
        ref_key: "ShrinkWrapRef",
        ref: ShrinkWrapRef
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'red-star': !_unref(isPay) })
              }, "是否炸机", 2),
              (!_unref(isPay))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(malfunctionRepairState).isBoom ? '' : '未') + "发生炸机", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, "无"))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'red-star': !_unref(isPay) })
                }, "故障日志", 2),
                (!_unref(malfunctionRepairState)?.selectedLogItem?.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "无"))
                  : _createCommentVNode("", true)
              ]),
              (_unref(malfunctionRepairState)?.selectedLogItem?.name)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(malfunctionRepairState)?.selectedLogItem?.name), 1),
                    _createElementVNode("div", _hoisted_10, "时长 " + _toDisplayString(_unref(malfunctionRepairState)?.selectedLogItem?.longStr), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["media-info van-hairline--top", { 'row-info': !_unref(imgList).length }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'red-star': !_unref(isPay) })
              }, "故障照片", 2),
              (_unref(imgList).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imgList), (item, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        src: item,
                        alt: "",
                        onClick: ($event: any) => (imagePreviewHandler(index)),
                        key: index
                      }, null, 8, _hoisted_12))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, "无"))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["description van-hairline--top", { 'row-info': !_unref(firstData).description.length }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'red-star': !_unref(isPay) })
              }, "故障描述", 2),
              (_unref(firstData).description.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(firstData).description), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, "无"))
            ], 2),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'red-star': !_unref(isPay) })
              }, "附件(故障视频、飞行日志文件等)", 2),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(UploadFile, {
                  maxCount: 3,
                  defaultList: _unref(annextList),
                  showUpload: false,
                  deletable: false
                }, null, 8, ["defaultList"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 512),
      _createVNode(CellWrap, {
        label: "回寄地址",
        style: {"margin-top":"12px"},
        fillColor: "rgba(0, 0, 0, 0.44)",
        onClick: toEditAddress
      }, {
        "cell-right": _withCtx(() => [
          (_unref(addressStr))
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(addressStr)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, "请填写回寄地址"))
        ]),
        _: 1
      })
    ]),
    _createVNode(RepairTypeTipDialog, {
      ref_key: "RepairTypeTipDialogRef",
      ref: RepairTypeTipDialogRef,
      onContinue: repairTypeTipContinue
    }, null, 512),
    _createVNode(CommonFooterNextButton, {
      title: "确认提单",
      onClick: preConfirmSubmit
    })
  ], 64))
}
}

})